module.exports = __webpack_public_path__ + "img/resources-1920.f67aad9e.jpg";